import React from 'react'
import { TopBar } from 'prove-common'
import { AppLogo } from '../app-logo/AppLogo'

export const NewsListScreenTopBar: React.FC = () => {
  const breadcrumbItems = [
    {
      label: 'Innstillinger',
      to: '/settings'
    },
    {
      label: 'Nyheter'
    }
  ]
  return (
    <TopBar
      logo={<AppLogo />}
      breadcrumbItems={breadcrumbItems}
      showNotificationBell={true}
    />
  )
}
